export default "__VITE_ASSET__JffNjGnv__"